
// export const logout = ( state ) => {
// }

export const setSites = (state, sites) => {
    state.sites = sites
}

export const setSitesSelectable = (state, sites) => {
    state.sitesSelectable = sites
}

export const setSitesPaginated = (state, sitesPaginatedData) => {
    state.sitesPaginatedData = sitesPaginatedData
}

export const setSiteDetail = (state, site) => {
    state.site = site
}

export const saveNewSites = (state, sites) => {
    state.sites.unshift(sites)
    state.createdData = sites;
}

export const saveNewSite = (state, site) => {
    state.sites.unshift(site)
    state.createdData = site;
}

export const saveUpdatedSite = (state, site) => {
    state.sites.unshift(site)
    state.updatedData = site;
}

export const setDeleteSite = (state, site) => {
    state.deletedData = site
}

export const setSiteIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setSiteIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setSiteIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setSiteIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}
